var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"id":"core-footer","app":"","absolute":"","height":"40"}},[_c('span',{staticClass:"font-weight-light copyright"},[_vm._v(" © "+_vm._s((new Date()).getFullYear())+" Zwono ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }